import React from 'react';
import LabelReportGroupedItemTable from './LabelReportGroupedItemTable';

const LabelReportGroupedChannels: React.FC = () => (
  <LabelReportGroupedItemTable
    dataKey='groupedChannels'
    tableId='LabelReportGroupedChannels'
  />
);

export default LabelReportGroupedChannels;
